module.exports = __webpack_public_path__ + "static/media/YB5F18_9.ea48de9b.jpg";